import Card from 'components/Card/Card';
import {useMemo, useState} from 'react';
import {YCTable} from '../../components/YCTable/YCTable';
import {EventRoleType, SportEventMember} from 'types/dto';
import {IconButton, Select, useDisclosure} from '@chakra-ui/react';
import {EditIcon} from '@chakra-ui/icons';
import UpdatePasswordModal from './UpdatePasswordModal';

interface PermissionTableProps {
  data: SportEventMember[] | undefined,
  handleUpdate: (updatedSportEventMember: Partial<SportEventMember>) => void;
  handlePasswordUpdate: (userId: number, newPassword: string) => void;
}

const PermissionTable: React.FC<PermissionTableProps> = ({
                                                           data,
                                                           handleUpdate,
                                                           handlePasswordUpdate
                                                         }) => {
  const [search, setSearch] = useState('');
  const {isOpen, onOpen, onClose} = useDisclosure();
  const [selectedSportEventMember, setSelectedSportEventMember] = useState<SportEventMember | undefined>(undefined);

  const handleRoleChange = (newEventRoleType: EventRoleType, member: SportEventMember) => {
    let updatedMember: SportEventMember = {
      ...member,
      eventRole: newEventRoleType
    }
    handleUpdate(updatedMember);
  };

  const columns = useMemo(
    () => [
      {
        Header: 'First Name',
        accessor: 'firstName',
      },
      {
        Header: 'Last Name',
        accessor: 'lastName',
      },
      {
        Header: 'Email',
        accessor: 'email',
      },
      {
        Header: 'Role',
        accessor: 'eventRole',
        Cell: ({row}: { row: { original: SportEventMember } }) => (
          <Select
            value={row.original.eventRole}
            onChange={(e) => handleRoleChange(e.target.value, row.original)}
          >
            {Object.values(EventRoleType).map((role) => (
              <option key={role} value={role}>
                {role}
              </option>
            ))}
          </Select>
        ),
      },
      {
        Header: 'Change Password',
        accessor: 'id',
        Cell: ({row}: { row: any }) => (
          <IconButton
            aria-label="Edit"
            icon={<EditIcon/>}
            onClick={() => {
              setSelectedSportEventMember(row.original);
              onOpen();
            }}
          />
        ),
      }
    ],
    []
  );

  return (
    <>
      <Card mt={2}>
        <YCTable columns={columns} data={data || []} search={search} setSearch={setSearch} useFlex/>
      </Card>
      <UpdatePasswordModal
        isOpen={isOpen}
        onOpen={onOpen}
        onClose={() => {
          setSelectedSportEventMember(undefined);
          onClose();
        }}
        sportEventMemberData={selectedSportEventMember}
        handleUpdate={handlePasswordUpdate}
      />
    </>
  );
};

export default PermissionTable;
